import React, { useState } from 'react';
import { Offcanvas, Card } from 'react-bootstrap';

import AdvanceTableProvider from 'providers/AdvanceTableProvider';

import useTableData from 'hooks/useTableData';
import useAdvanceTable from 'hooks/useAdvanceTable';

import TableBody from 'components/common/Table/TableBody';
import TablePagination from 'components/common/Table/TablePagination';

import { picklistApi } from 'api';

import { PICKLIST_PROCESS_ITEMS_COLUMNS } from 'constants/picklist';

const PicklistProductsTable = ({ picklistId }) => {
  const [pageIndex, setPageIndex] = useState(0);
  const pageSize = 25;

  const { data, totalItems, loading, error } = useTableData({
    apiService: picklistApi,
    method: 'getProductsOfPicklist',
    queryParams: {
      pageIndex,
      pageSize,
    },
    resourceId: picklistId,
    customConfig: {
      transformParams: params => {
        const transformedParams = new URLSearchParams();

        transformedParams.append('page', params.pageIndex + 1);
        transformedParams.append('page_size', params.pageSize);

        return transformedParams;
      },
    },
  });

  const table = useAdvanceTable({
    data: data || [],
    columns: PICKLIST_PROCESS_ITEMS_COLUMNS,
    manualPagination: true,
    sortable: false,
    totalItems,
    paginationState: { pageIndex, pageSize },
    onPaginationChange: ({
      pageIndex: newPageIndex,
      pageSize: newPageSize,
    }) => {
      setPageIndex(newPageIndex);
    },
  });

  return (
    <AdvanceTableProvider {...table}>
      <Card className="mb-3">
        <Card.Body className="p-0">
          {loading ? (
            <div className="text-center p-4">Loading...</div>
          ) : error ? (
            <div className="text-center p-4 text-danger">{error}</div>
          ) : data?.length === 0 ? (
            <div className="text-center p-4">No Items found</div>
          ) : (
            <TableBody
              headerClassName="bg-200 text-nowrap align-middle text-center"
              rowClassName="align-middle white-space-nowrap text-center"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs-10 mb-0 overflow-hidden',
              }}
            />
          )}
        </Card.Body>
        <Card.Footer>
          <TablePagination />
        </Card.Footer>
      </Card>
    </AdvanceTableProvider>
  );
};

const PicklistProductsPanel = ({ show, onHide, picklistId }) => {
  return (
    <Offcanvas show={show} onHide={onHide} placement="end" className="w-75">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>View Items</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        <PicklistProductsTable picklistId={picklistId} />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default PicklistProductsPanel;
